import api from ".";
import type { PaginatedList } from "src/types/api";
import type { PaymentRow } from "src/types/invoice";

/** Query accepted by the payments list endpoint. */
export interface PaymentQuery {
	page?: number;
	limit?: number;
	search?: string;
	store_or_warehouse_uuid?: string;
}

export const getPayments = (params?: PaymentQuery) => api.get<PaginatedList<PaymentRow>>("/payments", { params });

export const getPaymentDetails = (paymentId: string) => api.get<PaymentRow>(`/payments/${paymentId}`);

export const initiatePayment = (data: { transaction_type?: string; business_uuid?: string; amount?: number | string; [key: string]: unknown }) =>
	api.post<Record<string, unknown>>("/payments/initiate-payment", data);

export const verifyPayment = (data: { reference: string; business_uuid?: string }) => api.post("/payments/verify-payment", data);
